import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { forwardRef } from "react";
import { MetadataInputProps } from "../metadata-input-index";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const MetadataInputDateSingle = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { t } = useTranslation();
  const { onChange, data, value, value2, dateRange } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {dateRange ? (
        <>
          <DesktopDatePicker
            label={t("common:startDate")}
            value={value && value.valueLabel === "startDate" ? dayjs(value.value) : dayjs("")}
            onChange={(newValue) => {
              onChange(newValue?.toString(), data.id, undefined, undefined, "startDate");
            }}
            format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
          />
          <DesktopDatePicker
            label={t("common:endDate")}
            value={value2 && value2.valueLabel === "endDate" ? dayjs(value2.value) : dayjs("")}
            onChange={(newValue) => {
              onChange(newValue?.toString(), data.id, undefined, undefined, "endDate");
            }}
            format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
          />
        </>
      ) : (
        <DesktopDatePicker
          value={value ? dayjs(value.value || value) : dayjs("")}
          onChange={(newValue) => {
            onChange(newValue?.toString(), data.id);
          }}
          format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
          sx={{ mt: -3, width: "100%" }} // check if ok everywhere
        />
      )}
    </LocalizationProvider>
  );
});

export default MetadataInputDateSingle;
